import React from 'react';
import PropTypes from 'prop-types';


const EvaluationCompleteSVGPropTypes = {
  color: PropTypes.string.isRequired,
};

const EvaluationCompleteSVG = ({
  color,
}) => (
  <svg height="80" width="80">
    <g className="complete">
      {/* Colored circle */}
      <circle
        cx="40"
        cy="40"
        r="40"
        fill={color}
      />

      {/* Window */}
      <rect
        x="20"
        y="20"
        height="40"
        width="40"
        rx="2px"
        ry="2px"
        fill={color}
        stroke="#FFFFFF"
        strokeWidth="1"
      />

      {/* Top menu of faux window */}
      <circle cx="23" cy="23" r="1" fill="#FFFFFF" />
      <circle cx="26" cy="23" r="1" fill="#FFFFFF" />
      <circle cx="29" cy="23" r="1" fill="#FFFFFF" />
      <line x1="20" y1="26.5" x2="60" y2="26.5" stroke="#FFFFFF" strokeWidth="1" />

      {/* Check mark in circle */}
      <circle
        cx="40"
        cy="43"
        r="10"
        fill={color}
        stroke="#FFFFFF"
        strokeWidth="1"
      />
      <line x1="36" y1="43" x2="39.5" y2="47" stroke="#FFFFFF" strokeWidth="1" />
      <line x1="39.5" y1="47" x2="44" y2="39" stroke="#FFFFFF" strokeWidth="1" />
    </g>
  </svg>
);
EvaluationCompleteSVG.propTypes = EvaluationCompleteSVGPropTypes;

export default EvaluationCompleteSVG;
